// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"modal_modalDialog__1pey4","guideModal":"modal_guideModal__Nb-5O","spanX":"modal_spanX__p-pwq","modalHeader":"modal_modalHeader__ktyn9"};